<template lang="pug">
  //- Lite layout class when Presets column is off (Reports: absent | lite: page-reports-lite).
  div.page-reports(:class="{'page-reports-lite': !showPresets}")
      loading(:active.sync="busy", :is-full-page="true")
      .widget(v-if="filters && !date_filters_only")
          .widget-header
              h1.title {{ widgetTitle }}
              .submit-buttons(v-if="!editCustomPresets")
                  b-button-group
                      b-button(v-if="!hasExportMenuItems", @click="search()", variant="primary") Go
                      b-dropdown(v-else, @click="search()", variant="primary", right, split, text="Go")
                          b-dropdown-item(v-if="showExport", @click="search(1)")
                              i.la.la-download.mr-2
                              | Export
                          b-dropdown-item(v-if="showExportPage", @click="loadData(3)")
                              i.la.la-download.mr-2
                              | Export Page
                          b-dropdown-item(v-if="showBackgroundExport", @click="search(2)")
                              i.la.la-download.mr-2
                              | Background Report
                          b-dropdown-item(v-if="showBackgroundExport", @click="showBackgroundReportsModal(true)")
                              i.la.la-external-link.mr-2
                              | View Background Reports
                          b-dropdown-item(v-if="showSavePreset", @click="createCustomPreset()")
                              i.la.la-magic.mr-2
                              | Save to presets
          .widget-body

              form.form.ov-filters(@submit.prevent="search()", :class="{expanded:filtersExpanded}")
                  .row
                      .col-md-12.mb-4(v-if="presetEditInstance")
                          .d-flex.justify-content-between
                              .preset.form-inline
                                  .form-group
                                      label Preset Name
                                      input.form-control(type="text", v-model="presetEditInstance.name")
                                  .form-group
                                      label Date Range
                                      select.form-control(v-model="presetEditInstance.date_range", style="width: 120px;")
                                          option(value="") None
                                          option(v-for="o in presetDateRangeOptions", :value="o") {{ o }}
                                  .form-group
                                    label Color
                                    color-picker(v-model="presetEditInstance.color")

                              .submit-buttons.preset-edit
                                  button.btn.btn-default(type="button", @click="presetEditInstance = null", v-b-tooltip.bottom.hover, title="Discard changes") Cancel
                                  button.btn.btn-primary(type="button", @click="updateCustomPreset()", v-b-tooltip.bottom.hover, title="Save changes") Save
                  .row
                      .col-md-12
                          .form-blocks(:class="{'list-height-auto':showAllDims}")
                              .block.block-dimensions(:class="{'edit-preset':presetEditInstance}")
                                  .block-header
                                      h3 Dimensions
                                      .block-actions
                                          a.mr-2(href="javascript:void(0);", @click="showAllDims = !showAllDims")
                                              i.la(:class="{'la-arrows-alt-v': !showAllDims, 'la-minus-circle': showAllDims}")
                                  .block-body
                                      .selection-panel
                                          <!-- Search input -->
                                          input.form-control.form-control-sm.selection-search-input(type="text", placeholder="Search...", v-model="dimensionSearch", ref="dimensionSearchInput", @keydown.enter.prevent="submitSelectionSearch('dimension')")
                                          .selection-list
                                              <!-- Template for each category in filteredDimensionList -->
                                              template(v-for="(entry, idx) in filteredDimensionList", :key="entry.type === 'category' ? 'cat-' + entry.label : entry.item.name")
                                                  div.list-category(v-if="entry.type === 'category'") {{ entry.label }}
                                                  div.list-item(v-else, :class="{selected:entry.item._selected}")
                                                      <!-- Expand/Collapse button -->
                                                      a.btn-item-left(v-if="entry.item.children", href="javascript:void(0);", @click="entry.item._expanded = !entry.item._expanded")
                                                          i.la(:class="{'la-caret-right': !entry.item._expanded, 'la-caret-down': entry.item._expanded}")
                                                      a.btn-item-right(@keydown.enter.prevent, v-if="entry.item.children", href="javascript:void(0)", @click="toggleAllChildren(entry.item)")
                                                          i.la.la-check-square
                                                      b-checkbox(:checked="entry.item._selected", :class="{symbolic:entry.item.symbolic}", :disabled="entry.item.symbolic", @change="(value) => changeDimensionSelection(entry.item.field, value)") {{ entry.item.label }}
                                                          =' '
                                                          span(v-if="entry.item.children") ({{ entry.item.children | countSelected }})
                                                          new-feature(v-if="entry.item.new_tag")
                                                      div(v-if="entry.item.children", v-show="entry.item._expanded")
                                                          template(v-for="cd in entry.item.children", :key="cd.name || cd.field")
                                                              div.child(v-if="childVisible(cd, dimensionSearchQuery)", :class="{selected:cd._selected}")
                                                                  b-checkbox(:checked="cd._selected", @change="(value) => changeDimensionChildSelection(entry.item, cd, value)") {{ cd.label }}
                                                                      new-feature(v-if="entry.item.new_tag")
                                      <!-- Selected Dimensions items -->
                                      .selected-items
                                          div(v-for="d in selectedDimensions")
                                              a(href="javascript:void(0);", @click="removeDimension(d)")
                                                  i.la.la-times
                                              span {{ d.label }}

                                              template(v-for="cd in d.children", :key="cd.name || cd.field")
                                                  div(v-if="cd._selected", class="ml-3")
                                                      a(href="javascript:void(0);", @click="removeDimension(cd)")
                                                          i.la.la-times
                                                      span {{ cd.label }}
                                              

                              .block.block-metrics(:class="{'edit-preset':presetEditInstance}")
                                  .block-header
                                      h3 Metrics
                                      .block-actions
                                          toggle-button(v-if="showAccumulative", v-model="accumulative", sync="true", @change="toggleAccumulativeMode", :labels="{checked: 'Accumulative', unchecked: ''}", :color="{checked: '#ffb047'}", :width="accumulative ? 90 : 40", :height="16", :font-size="8", v-b-tooltip.bottom.hover, title="Accumulative mode will group data by hour and display the total for each hour")
                                  .block-body
                                      .selection-panel
                                          <!-- Search input -->
                                          input.form-control.form-control-sm.selection-search-input(type="text", placeholder="Search...", v-model="metricSearch", ref="metricSearchInput", @keydown.enter.prevent="submitSelectionSearch('metric')")
                                          .selection-list.selection-list-wide
                                              div.list-item(v-for="d in filteredMetrics", :class="{selected:d._selected}")
                                                  a.btn-item-left(v-if="d.children", href="javascript:void(0);", @click="d._expanded = !d._expanded")
                                                      i.la(:class="{'la-caret-right': !d._expanded, 'la-caret-down': d._expanded}")
                                                  a.btn-item-right(@keydown.enter.prevent, v-if="d.children && areAllMetricsEnabled(d)", href="javascript:void(0)", @click="areAllMetricsEnabled(d) && toggleAllChildren(d)")
                                                      i.la.la-check-square
                                                  b-checkbox(v-model="d._selected", :class="{symbolic:d.symbolic, 'text-muted': !areAllMetricsEnabled(d)}", :disabled="d.symbolic", v-b-tooltip.bottom.hover, :title="d.info")
                                                    span {{ d.label }}  
                                                    span(v-if="d.children") ({{ d.children | countSelected }})
                                                  div(v-if="d.children", v-show="d._expanded")
                                                      template(v-for="cd in d.children", :key="cd.name")
                                                          div.child(v-if="childVisible(cd, metricSearchQuery)", :class="{selected:cd._selected}")
                                                              b-checkbox(v-model="cd._selected", :disabled="!cd._enabled", v-b-tooltip.bottom.hover, :title="cd.info") {{ cd.label }}
                                      <!-- Selected Metrics items -->
                                      .selected-items
                                          div(v-for="entry in selectedMetricItems", :class="{'ml-3': entry.isChild}")
                                              a(href="javascript:void(0);", @click="removeMetric(entry.item)")
                                                  i.la.la-times
                                              span {{ entry.item.label }}
                              .block.block-presets(v-if="showPresets")
                                  .block-header
                                      h3 Presets
                                      .block-actions
                                          // a.mr-2(v-if="!editCustomPresets", href="javascript:void(0);", @click="createCustomPreset()") Add
                                          a.mr-2(v-if="!presetEditInstance", href="javascript:void(0);", @click="editCustomPresets = !editCustomPresets") {{ !editCustomPresets ? 'Edit' : 'Cancel' }}
                                  .block-body
                                      .preset-list(v-if="!editCustomPresets")
                                          button.rounded-pill.preset-btn(v-for="p in customPresets", :key="p.id", :class="{'btn-default': p.is_default, 'selected': selectedPreset && selectedPreset.id === p.id}", type="button", @click="selectCustomPreset(p)", :style="{'background-color': p.color}")
                                              span {{ p.name }} &nbsp;
                                              i.la.la-star(v-if="p.is_default")

                                      draggable.selection-list.edit-mode(v-if="editCustomPresets", tag="tbody", v-model="customPresets", handle=".drag-handle", ghost-class="ghost", :group="{name: 'customPresets', pull: 'clone', put: false}", @end="onPresetDrag")
                                          .list-item(v-for="p in customPresets", :key="p.id", :class="{'default':p.is_default, 'highlight': presetEditInstance && presetEditInstance.id === p.id}")
                                              a.btn-item-left.drag-handle(type="button", v-b-tooltip.bottom.hover, title="Drag to change order", v-if="!presetEditInstance")
                                                  i.la.la-grip-lines
                                              .btn-item-right(v-if="!presetEditInstance")
                                                  a.icon-btn.mr-1(type="button", @click="editCustomPreset(p)", v-b-tooltip.bottom.hover, title="Edit")
                                                      i.la.la-pencil
                                                  a.icon-btn.mr-1(type="button", @click="togglePresetDefault(p)", v-b-tooltip.bottom.hover, title="Set As Default", v-if="!p.is_default")
                                                      i.la.la-star
                                                  a.icon-btn.mr-1.btn-danger(type="button", @click="deleteCustomPreset(p)", v-b-tooltip.bottom.hover, title="Delete")
                                                      i.la.la-trash
                                              .item-text.pr-5 {{ p.name }}
                      .col-md-12
                          .form-blocks(v-if="filters")
                              .block.block-filters(:class="{'edit-preset':presetEditInstance}")
                                  .block-header
                                      h3 Filters
                                      .block-actions
                                          a.mr-2.mobile-visible(href="javascript:void(0);", @click="toggleFilters()", v-b-tooltip.bottom.hover, :title="filtersExpanded ? 'Show Less' : 'Expand Filters'")
                                              i.la(:class="{'la-plus-circle': !filtersExpanded, 'la-minus-circle': filtersExpanded}")
                                          a.mr-2(href="javascript:void(0);", @click="clearFilters()") Clear
                                  .block-body
                                      .mr-3(v-if="presetEditInstance")
                                          label Preset Filters
                                              i.la.la-info-circle.ml-1(v-b-tooltip.hover, title="Selected filters will reset to the desired option when the preset will be used")
                                          .selection-list(style="width: 200px; height: 240px")
                                              div(v-for="f in filtersOptions.filter(f => !f.hidden && f.field !== 'datePicker')", :class="{selected: !presetEditInstance.activeFilters[f.field]}")
                                                  b-checkbox(v-model="presetEditInstance.activeFilters[f.field]") {{ f.label }}
                                      .form-inline
                                          ov-date-time-picker.date-range-picker(v-model="filters.datePicker", ref="datePickerRef", :minimized="!filtersExpanded", :limitThreeMonths="shouldLimitDateRange", @change="onDateTimeChange")
                                          .form-group(v-if="isFilterVisible('group_timeframe')")
                                              label Group Timeframe
                                              select.form-control(v-model="filters.group_timeframe", style="width: 120px;", @change="onTimegroupChange")
                                                  option(v-for="o in groupTimeframeOptions", :value="o.v") {{ o.t }}
                                          .form-group(v-if="isFilterVisible('media_type')")
                                              label Media Type
                                              multiselect(:multiple="true", :options="mediaTypeOptions", v-model="filters.media_type",
                                                  track-by="v", label="t", placeholder="All", deselect-label="", select-label="")

                                          .form-group(v-if="isFilterVisible('attribution_type')")
                                              label Attribution Type
                                              select.form-control(v-model="filters.attribution_type")
                                                  option(:value="null") All
                                                  option(:value="0") Click
                                                  option(:value="1") Impression


                                          select-publisher(v-if="isFilterVisible('publisher_id')", :class="{'mobile-hidden': !filtersExpanded && !filters.publisher_id.length}", v-model="filters.publisher_id")
                                          select-placement(v-if="isFilterVisible('placement_id')", :class="{'mobile-hidden': !filtersExpanded && !filters.placement_id.length}", v-model="filters.placement_id")
                                          select-advertiser(v-if="isFilterVisible('advertiser_id')", :class="{'mobile-hidden': !filtersExpanded && !filters.advertiser_id.length}", v-model="filters.advertiser_id")
                                          select-offer(v-if="isFilterVisible('offer_id')", :class="{'mobile-hidden': !filtersExpanded && !filters.offer_id.length}", v-model="filters.offer_id")
                                          select-offer(v-if="isFilterVisible('complex_offer_id')", :class="{'mobile-hidden': !filtersExpanded && !filters.complex_offer_id.length}", v-model="filters.complex_offer_id", :complex="true")
                                          select-os-version(v-if="isFilterVisible('os_version_id')", :class="{'mobile-hidden': !filtersExpanded && !filters.os_version_id.length}", v-model="filters.os_version_id")

                                          .form-group(v-if="isFilterVisible('os_id')", :class="{'mobile-hidden': !filtersExpanded && !filters.os_id.length}")
                                              label OS
                                              multiselect(:multiple="true", :options="osOptions", v-model="filters.os_id",
                                                  track-by="v", label="t", deselect-label="", select-label="")
                                          .form-group(v-if="isFilterVisible('device_id')", :class="{'mobile-hidden': !filtersExpanded && !filters.device_id.length}")
                                              label Device
                                              multiselect(:multiple="true", :options="deviceOptions", v-model="filters.device_id",
                                                  track-by="v", label="t", deselect-label="", select-label="")
                                          .form-group(v-if="isFilterVisible('browser_id')", :class="{'mobile-hidden': !filtersExpanded && !filters.browser_id.length}")
                                              label Browser
                                              multiselect(:multiple="true", :options="browserOptions", v-model="filters.browser_id",
                                                  track-by="v", label="t", deselect-label="", select-label="")
                                          .form-group(v-if="isFilterVisible('carrier_id')", :class="{'mobile-hidden': !filtersExpanded && !filters.carrier_id.length}")
                                              label Mobile Carrier
                                              multiselect(:multiple="true", :options="carrierOptions", v-model="filters.carrier_id",
                                                  track-by="v", label="t", deselect-label="", select-label="")
                                          .form-group(v-if="isFilterVisible('isp_id')", :class="{'mobile-hidden': !filtersExpanded && !filters.isp_id.length}")
                                              label ISP
                                              multiselect(:multiple="true", :options="ispOptions", v-model="filters.isp_id",
                                                  track-by="v", label="t", deselect-label="", select-label="", placeholder="All",
                                                  :internal-search="false", :loading="ispOptionsLoading", @search-change="searchIsp")
                                          .form-group(v-if="isFilterVisible('country')", :class="{'mobile-hidden': !filtersExpanded && !filters.country.length}")
                                              label Country
                                              multiselect(:multiple="true", :options="countryOptions", v-model="filters.country",
                                                  track-by="v", label="t", deselect-label="", select-label="", placeholder="All")
                                          .form-group(v-if="isFilterVisible('groups_mode')", :class="{'mobile-hidden': !filtersExpanded && !filters.groups_mode}")
                                              label Smartlink Traffic
                                              select.form-control(v-model="filters.groups_mode")
                                                  option(:value="0") None
                                                  option(:value="1") Smartlink-Only
                                                  option(:value="2") All
                                          .form-group(v-if="isFilterVisible('placement_po_model')", :class="{'mobile-hidden': !filtersExpanded && !filters.placement_po_model}")
                                              label Placement PO
                                              // label 
                                                  | Placement PO
                                                  new-feature
                                              select.form-control(v-model="filters.placement_po_model")
                                                  option(value="") All
                                                  option(value="CPI") CPI
                                                  option(value="CPA") CPA
                                          .form-group(v-if="isFilterVisible('am_id')", :class="{'mobile-hidden': !filtersExpanded && !filters.am_id.length}")
                                              label Account Manager
                                              multiselect(:multiple="true", :options="accountManagerOptions", v-model="filters.am_id",
                                                  track-by="v", label="t", deselect-label="", select-label="")
                                          .form-group(v-if="isFilterVisible('mmp_account_id')", :class="{'mobile-hidden': !filtersExpanded && !filters.mmp_account_id.length}")
                                              label MMP Account
                                              multiselect(:multiple="true", :options="mmpAccountOptions", v-model="filters.mmp_account_id",
                                                  track-by="v", label="t", deselect-label="", select-label="")
                                                  
                                          select-subsource(v-if="isFilterVisible('sub1_id')", v-model="filters.sub1_id", type="sub1")
                                          select-subsource(v-if="isFilterVisible('sub2_id')", v-model="filters.sub2_id", type="sub2")
                                          
                                          .form-group(v-if="isFilterVisible('conversions_mode')", :class="{'mobile-hidden': !filtersExpanded && filters.conversions_mode === 0}")
                                              label Conversions / Events
                                              select.form-control(v-model="filters.conversions_mode")
                                                  option(:value="0") All
                                                  option(:value="1") Has Conversions / Events
                                                  option(:value="2") No Conversions / Events
                                          
                                          .form-group.no-label(v-if="isFilterVisible('subsource_data') && selectedDimensionHash.subsource", :class="{'mobile-hidden': !filtersExpanded && !filters.subsource_data}")
                                              label.form-check-label
                                              b-checkbox(type="checkbox", v-model="filters.subsource_data") Expand Subsources
                                          
                                          .form-group.no-label(v-if="isFilterVisible('cohort')", :class="{'mobile-hidden': !filtersExpanded && !filters.cohort}")
                                              b-checkbox(type="checkbox", v-model="filters.cohort") Cohort
                                          


      .widget
          .widget-body
              form.form.ov-filters.minimal-filters.flex-container(@submit.prevent="search()", v-if="date_filters_only")
                  .filters-row
                      ov-date-time-picker.date-range-picker(v-model="filters.datePicker", ref="datePickerRef")
                      //a.btn-underline.ml-2(href="javascript:void(0);", @click="date_filters_only=false") Show all filters &nbsp;
                          i.la.la-angle-up
                  .flex-right
                      b-button-group.mt-4
                          b-button(v-if="!hasExportMenuItems", type="submit", variant="primary") Go
                          b-dropdown(v-else, split-button-type="submit", variant="primary", right, split, text="Go")
                              b-dropdown-item(v-if="showExport", @click="search(1)")
                                  i.la.la-download.mr-2
                                  | Export

              p.clearfix.mobile-hidden &nbsp;
              paginate(:paginator="paginate", @update-page-size="loadData", :refresh="true")


              ov-table-scroll(body-class="stats-table-wrapper")
                  table.table.table-bordered.tbl-statistics(v-if="resultMeta")
                      thead
                          tr
                              ov-th.col-timeframe(v-if="filters.group_timeframe === 'day' || filters.group_timeframe === 'hour' || filters.group_timeframe === 'week' || filters.group_timeframe === 'month' || filters.group_timeframe==='hourByDays'", @sort="doSort($event)", :sorter="sortBy", :field="filters.group_timeframe") {{timeframeLabel[filters.group_timeframe] }}
                              template(v-for="d in resultMeta.dimensions", :key="d.name")
                                  ov-th.col-dim(:class="'col-'+d.name", @sort="doSort($event)", :sorter="sortBy", :field="d.name") {{ d.label }}
                                  template(v-if="d.children")
                                    template(v-for="c in d.children", :key="d.name + '__' + c.name")
                                      ov-th.col-info(@sort="doSort($event)", :sorter="sortBy", :field="d.name+'__'+c.name") {{ c.label }}
                              ov-th.col-metric(v-for="m in resultMeta.metrics", :class="'col-'+m.name", @sort="doSort($event)", :sorter="sortBy", :field="m.name") {{ m.short_label || m.label }}

                      tbody.summary
                        tr(v-if="summary")
                            td.c(v-if="filters.group_timeframe === 'day' || filters.group_timeframe === 'hour'  || filters.group_timeframe === 'week' || filters.group_timeframe === 'month' || filters.group_timeframe==='hourByDays'") &nbsp;
                            template(v-for="d in resultMeta.dimensions", :key="d.name")
                                td &nbsp;
                                template(v-if="d.children")
                                  template(v-for="c in d.children", :key="d.name + '__' + c.name")
                                    td &nbsp;
                            td.c(v-for="d in resultMeta.metrics", :class="'col-'+d.name")
                                span {{ formatSummaryValue(summary[d.name]) }}

                      tbody(ref="table")
                        tr(v-if="records.length===0")
                            td(:colspan="numColumns") No matching records were found
                        tr(v-for="r in records", v-bind:key="r.key", :class="getRowClass(r)")
                            td.nowrap(v-if="filters.group_timeframe === 'month'") {{ r.group_month }}
                            td.nowrap(v-if="filters.group_timeframe === 'week'") {{ r.group_week }}
                            td.nowrap(v-if="filters.group_timeframe === 'day'") {{ r.group_date }}
                            td.nowrap(v-if="filters.group_timeframe === 'hour'") {{ r.group_hour }}
                            td.nowrap(v-if="filters.group_timeframe === 'hourByDays'") {{ r.group_hour }}
                            template(v-for="d in resultMeta.dimensions", :key="d.name")
                                td.col-entity(:class="getColClass(r, d)")
                                    entity.no-bg(v-if="r[d.name] && r[d.name].id", :id="r[d.name].id", :name.sync="r[d.name].name", :type="d.name",
                                        :mode="d.mode", :data="r[d.name]",
                                        :max-width="d.width", @click="appendEntity(r,d)", @dblclick="selectEntity(r,d)")
                                    span(v-if="!r[d.name] || !r[d.name].id", @click="appendEntity(r,d)") {{ r[d.field] }}
                                template(v-if="d.children")
                                  template(v-for="c in d.children", :key="d.name + '__' + c.name")
                                    td.col-info
                                        offer-paused-reason(v-if="c.name==='paused_reason'", :offer="r.offer", :placement="d.name === 'placement' ? r.placement : null")
                                        offer-vta-indicator(v-else-if="c.name === 'campaign_type' && r[d.name]" :value="r[d.name][c.name]")
                                        span(v-else-if="r[d.name] && r[d.name][c.name]") {{ r[d.name][c.name].toLocaleString() }}
                                            //span(v-else="r[d.name] && r[d.name][c.name]") {{ r[d.name][c.name] }}

                            td.c(v-for="d in resultMeta.metrics", :class="'col-'+d.name + ' flag-'+(r[d.name] ? r[d.name].flag : '')",
                                v-b-tooltip.hover, :title="r[d.name] && r[d.name].l ? r[d.name].l : ''")
                                span(v-if="r[d.name]", :class="'flag-'+r[d.name].flag")
                                    router-link(v-if="metricsHash[d.name].link", :to="{name: metricsHash[d.name].link, query: getURLFiltersParams(r, metricsHash[d.name].linkParams)}") {{ r[d.name].v.toLocaleString() }}
                                    span(v-if="!metricsHash[d.name].link") {{ r[d.name].v.toLocaleString() }}

                      tfoot.summary
                        tr(v-if="summary")
                            th.c(v-if="filters.group_timeframe === 'day' || filters.group_timeframe === 'hour' || filters.group_timeframe === 'week' || filters.group_timeframe === 'month' || filters.group_timeframe==='hourByDays'") &nbsp;
                            template(v-for="d in resultMeta.dimensions", :key="d.name")
                                td &nbsp;
                                template(v-if="d.children")
                                  template(v-for="c in d.children", :key="d.name + '__' + c.name")
                                    td &nbsp;
                            th.c(v-for="d in resultMeta.metrics", :class="'col-'+d.name")
                                span {{ formatSummaryValue(summary[d.name]) }}


              paginate(:paginator="paginate", @update-page-size="loadData", :refresh="true")
</template>
<script>
import Vue from 'vue';
import GeneratedReportsModal from '@/views/reports/GeneratedReportsModal';
import CreatePresetModal from '../views/modals/CreatePresetModal';
import moment from 'moment';
import draggable from '@/components/OvDraggable.vue';
import { downloadFile } from '../lib/files';
import { copy } from '../lib/objects';
import { shouldResetPageForQuery } from '../lib/paginate';
import { getMediaTypeFilterValues } from '../lib/reportFilters.mjs';

const DEFAULT_DIMENSIONS = ['advertiser', 'offer'];
const DEFAULT_METRICS = [
'impressions',
'blocked_impressions',
'passed_impressions',
'clicks',
'blocked_clicks',
'passed_clicks',
'blocked_percent',
'conversions',
'reported_conversions',
'cr',
'cr_reported',
'installs',
'imp_per_install',
'events',
'reject_events',
'revenue',
'cost',
'profit',
'profit_percent',
...Array.from({ length: 10 }, (v, i) => 'e' + (i + 1)),
];

function getDefaultSortBy() {
return [
  {
    field: 'revenue',
    direction: 'desc',
    sort: null
  }
];
}

export default {
name: 'ReportsWidget',
components: {
  GeneratedReportsModal,
  CreatePresetModal,
  draggable,
},
props: {
  date_filters_only: {
    type: Boolean,
    default() {
      return false;
    },
  },
  os_version_id: {
    type: [String, Number],
    default() {
      return '';
    },
  },
  complex_offer_id: {
    type: [String, Number],
    default() {
      return '';
    },
  },
  offer_id: {
    type: [String, Number],
    default() {
      return '';
    },
  },
  placement_id: {
    type: [String, Number],
    default() {
      return '';
    },
  },
  // Optional lite-mode overrides; omit config on regular Reports (all defaults below apply).
  config: {
    type: Object,
  },
},
computed: {
  USER() {
    return this.$store.state.user;
  },
  // Page title (Reports: "Reports" | lite: e.g. "External Cost Data").
  widgetTitle() {
    return (this.config && this.config.title) || 'Reports';
  },
  // Form bootstrap endpoint (Reports: reports/getFormInfo | lite: external-cost-data-report/getFormInfo).
  formInfoUrl() {
    return (this.config && this.config.formInfoUrl) || 'reports/getFormInfo';
  },
  // Query endpoint (Reports: reports/query | lite: external-cost-data-report/query).
  queryUrl() {
    return (this.config && this.config.queryUrl) || 'reports/query';
  },
  // Presets column (Reports: true | lite: false).
  showPresets() {
    return !this.config || this.config.showPresets !== false;
  },
  // Background export menu item (Reports: true | lite: false).
  showBackgroundExport() {
    return !this.config || this.config.showBackgroundExport !== false;
  },
  // Save-to-presets menu item (Reports: true | lite: false).
  showSavePreset() {
    return !this.config || this.config.showSavePreset !== false;
  },
  // Export-page menu item (Reports: true | lite: false).
  showExportPage() {
    return !this.config || this.config.showExportPage !== false;
  },
  // File export menu item (Reports: true | lite: true — often the only export option in lite).
  showExport() {
    return !this.config || this.config.showExport !== false;
  },
  // Skip metric drill-down links (Reports: false | lite: true).
  disableMetricLinks() {
    return !!(this.config && this.config.disableMetricLinks);
  },
  // Hide timezone on date picker (Reports: false | lite: true).
  hideTimezone() {
    return !!(this.config && this.config.hideTimezone);
  },
  // Use split Go dropdown when any export/preset action is enabled (lite: true if showExport only).
  hasExportMenuItems() {
    return (
      this.showExport ||
      this.showExportPage ||
      this.showBackgroundExport ||
      this.showSavePreset
    );
  },
  // Accumulative toggle (Reports: feature-flag + true | lite: false via showAccumulative).
  showAccumulative() {
    return this.USER.config.accumulativeReports && (!this.config || this.config.showAccumulative !== false);
  },
  // Initial selected dimensions (Reports: advertiser+offer | lite: publisher+advertiser+offer).
  configuredDefaultDimensions() {
    return (this.config && this.config.defaultDimensions) || DEFAULT_DIMENSIONS;
  },
  // Initial selected metrics (Reports: DEFAULT_METRICS | lite: impressions…cr subset).
  configuredDefaultMetrics() {
    return (this.config && this.config.defaultMetrics) || DEFAULT_METRICS;
  },
  // Group Timeframe dropdown options (Reports: none/hour/day/week/month | lite: none/day/week/month).
  groupTimeframeOptions() {
    const defaults = [
      { v: 'none', t: 'None' },
      { v: 'hour', t: 'Hour' },
      { v: 'day', t: 'Day' },
      { v: 'week', t: 'Week' },
      { v: 'month', t: 'Month' },
    ];
    if (!this.config || !this.config.groupTimeframeOptions) {
      return defaults;
    }
    const labels = {
      none: 'None',
      hour: 'Hour',
      day: 'Day',
      week: 'Week',
      month: 'Month',
    };
    return this.config.groupTimeframeOptions.map((v) => ({
      v,
      t: labels[v] || v,
    }));
  },
  selectedDimensionHash() {
    let h = {};
    this.dimensions.forEach((d) => {
      if (d._selected) {
        h[d.name] = d;
      }
    });
    return h;
  },
  selectedDimensions() {
    return this.dimensions.filter((d) => d._selected);
  },
  selectedMetrics() {
    return this.metrics.filter(
      (d) => d._selected || (d.children && d.children.filter((c) => c._selected).length),
    );
  },

  // Search queries
  dimensionSearchQuery() {
    return this.dimensionSearch.trim().toLowerCase();
  },
  metricSearchQuery() {
    return this.metricSearch.trim().toLowerCase();
  },

  // Source list: dimensions -> returns dimensionDisplayList (a flat list for rendering).
  // Only *parent* dimensions are included in this list.
  // Child dimensions remain under `item.children` and are rendered from their parent.
  //
  // Returned structure:
  // [
  //   { type: 'category', label: 'Category 1' },
  //   { type: 'dimension', item: { name: 'Dimension 1', label: 'Dimension 1' } },
  //   { type: 'category', label: 'Category 2' },
  // ]
  filteredDimensionList() {

    // Search query
    const q = this.dimensionSearchQuery;
    const matching = this.dimensions.filter((d) => this.matchesSearch(d, q));

    // Category groups variables
    const categoryOrder = [];
    const categoryGroups = {};
    const uncategorized = [];

    // Build category groups
    this.dimensions.forEach((d) => {
      if (d.category && !categoryGroups[d.category]) {
        categoryGroups[d.category] = [];
        categoryOrder.push(d.category);
      }
    });

    // Split (matching dimensions) into categories
    matching.forEach((d) => {

      // No category -> Add to uncategorized
      if (!d.category) {
        uncategorized.push(d);
        return;
      }

      // Add to category
      categoryGroups[d.category].push(d);
    });

    // Build return list
    const list = [];
    uncategorized.forEach((d) => list.push({ type: 'dimension', item: d })); // uncategorized -> regular dimension

    // For each category
    categoryOrder.forEach((cat) => {
      const items = categoryGroups[cat];
      if (!items.length) { return; }

      list.push({ type: 'category', label: cat }); // Add category header
      items.forEach((d) => list.push({ type: 'dimension', item: d })); // Add category items
    });
    return list;
  },

  // Source list: metricsWithEnabled -> Return filteredMetrics
  filteredMetrics() {
    const q = this.metricSearchQuery;
    return this.metricsWithEnabled.filter((d) => this.matchesSearch(d, q));
  },

  // Returns a flat list of selected metrics (parents + children)
  selectedMetricItems() {
    const items = [];
    this.metrics.forEach((m) => {
      if (m._selected) {
        items.push({ item: m, isChild: false });
      }
      if (m.children) {
        m.children.forEach((cm) => {
          if (cm._selected) {
            items.push({ item: cm, isChild: true });
          }
        });
      }
    });
    return items;
  },
  visibleAdvertiserOptions() {
    return this.advertiserOptions.filter((a) => {
      return this.advertiserOptionsArchive || a.status;
    });
  },
  visiblePublisherOptions() {
    return this.publisherOptions.filter((a) => {
      return this.publisherOptionsArchive || a.status;
    });
  },
  numColumns() {
    let metrics = this.getSelectedMetrics();
    let dimensions = this.getSelectedDimensions();

    return metrics.length + dimensions.length + (this.filters.group_timeframe !== 'none' ? 1 : 0);
  },
  shouldLimitDateRange() {
    const hasBigDimension = this.selectedDimensions.some((d) => d.level === 3 || d.level === 4);
    return hasBigDimension;
  },
  mediaTypeOptions() {
    const options = [
      { v: 'dsp', t: 'DSP' },
      { v: 'rewarded', t: 'Rewarded' },
    ];
    if (this.USER && this.USER.config.leadGen) {
      options.push({ v: 'leadgen', t: 'LeadGen' });
    }
    if (this.USER && (this.USER.config.mediaBuyingSync || this.USER.config.cpmCost)) {
      options.push({ v: 'media_buying', t: 'Media Buying' });
    }
    return options;
  },
  metricsWithEnabled() {
    const vm = this;
    const selected = this.dimensions.filter(d => d._selected).map(d => d.name);

    const applyRule = (metric) => {
      const rule = this.MetricsValidationRules.metrics[metric.name];

      // If no rule, metric is enabled
      if (!rule) {
        metric._enabled = true;
        if (metric.children) metric.children.forEach(cd => applyRule(cd));
        return;
      }

      // Check 1: requiredDimension must be selected
      if (rule.requiredDimension && !selected.includes(rule.requiredDimension)) {
        metric._enabled = false;
        if (metric.children) metric.children.forEach(cd => applyRule(cd));
        return;
      }

      // Check 2: all selected dimensions must be either required or allowed
      if (selected.length > 0 && selected.some(name =>
        name !== rule.requiredDimension &&
        (!rule.allowedDimensions || !rule.allowedDimensions.includes(name))
      )) {
        metric._enabled = false;
        if (metric.children) metric.children.forEach(cd => applyRule(cd));
        return;
      }
      const unwrap = val =>
        val && typeof val === 'object'
          ? JSON.parse(JSON.stringify(val))
          : val;

      // Check 3: disable metric if any filter is not default or datePicker is not full-day
      const allFiltersDefault = vm.filtersOptions.every(f =>
        vm.filters[f.field] === undefined || // undefined filter consider as default
        (rule.allowedFilters && rule.allowedFilters[f.field] && (rule.allowedFilters[f.field].any === true) || Array.isArray(rule.allowedFilters[f.field]) && rule.allowedFilters[f.field].includes(vm.filters[f.field])) ||
        JSON.stringify(vm.filters[f.field]) === JSON.stringify(unwrap(f.defaultValue)) || // (deep) compare filter value with default
        (f.field === "user_id" && vm.filters[f.field] === vm.$store.state.user.id) // special case: user_id matches current user
      );
      
      let datePickerDefault = false;
      if (rule.allowedFilters && rule.allowedFilters.datePicker) {
          const tzOk = !rule.allowedFilters.datePicker.timezoneZero ||
                      vm.filters.datePicker.timezone == 0; // using == because initially set to 0 (number) but after update may be string (for example '0')
          const datesOk = !rule.allowedFilters.datePicker.fullDay ||    
                          ((!vm.filters.datePicker.dateRange.startDate || 
                          moment(vm.filters.datePicker.dateRange.startDate).format('HH:mm') === '00:00') && // if startDate exists, must be 00:00 to represent full-day
                          (!vm.filters.datePicker.dateRange.endDate || 
                          moment(vm.filters.datePicker.dateRange.endDate).format('HH:mm') === '23:59')); // if endDate exists, must be 23:59 to represent full-day
          datePickerDefault = tzOk && datesOk;
      } else {
          datePickerDefault = true;
      }

      if (!allFiltersDefault || !datePickerDefault) {
        metric._enabled = false;
        if (metric.children) metric.children.forEach(cd => applyRule(cd));
        return;
      }

      // Passed all checks
      metric._enabled = true;

      // Update children recursively
      if (metric.children) {
        metric.children.forEach(cd => applyRule(cd));
      }
    };

    this.metrics.forEach(metric => applyRule(metric));

    return this.metrics; // returns the original array with _enabled updated
  }
},
data() {
  return {
    dimOfferIndex: -1,
    dimPlacementIndex: -1,
    busy: false,
    paginate: {
      numPages: 0,
      total: 0,
      page: 1,
      limit: 50,
      onPageChange: () => {
        this.loadData();
      },
    },
    filtersExpanded: false,
    filtersOptions: [],
    showAllDims: false,
    dimensionSearch: '',
    metricSearch: '',
    sortBy: getDefaultSortBy(),
    dimensions: [],
    metrics: [],
    dimHash: {},
    metricsHash: {},
    ctitSteps: [],
    rejectReasons: [],
    MetricsValidationRules: [],
    blockedErrors: [],
    columns: [],
    pages: [],
    records: [],
    summary: null,
    resultMeta: null,
    advertiserOptionsArchive: false,
    publisherOptionsArchive: false,
    advertiserOptions: [],
    placementOptionsLoading: false,
    placementOptions: [],
    accountManagerOptions: [],
    mmpAccountOptions: [],
    publisherOptions: [],
    osOptions: [],
    deviceOptions: [],
    browserOptions: [],
    carrierOptions: [],
    ispOptions: [],
    ispOptionsLoading: false,
    ispSearchTimer: null,
    countryOptions: [],
    accumulative: false,
    filters: {
      cohort: false,
      groups_mode: 0,
      conversions_mode: 0,
      subsource_data: false,
      group_timeframe: 'none',
      extended_params: false,
      mmp_account_id: [],
      os_version_id: [],
      complex_offer_id: [],
      offer_id: [],
      placement_id: [],
      publisher_id: [],
      advertiser_id: [],
      am_id: [],
      os_id: [],
      device_id: [],
      browser_id: [],
      carrier_id: [],
      isp_id: [],
      sub1_id: [],
      sub2_id: [],
      country: [],
      media_type: [],
      attribution_type: null,
      placement_po_model: '',
      user_id: 0,
      datePicker: {
        timezone: 0,
        dateRange: {
          startDate: null,
          endDate: null,
        },
      },
    },
    timeframeLabel: {
      month: 'Month',
      week: 'Week',
      day: 'Date',
      hour: 'Hour',
      hourByDays: 'Hour',
    },
    customPresets: [],
    editCustomPresets: false,
    expandCustomPresets: false,
    presetEditInstance: false,
    selectedPreset: null,
    previousQueryParams: null,
  };
},
watch: {
  dimensionSearch() {
    this.expandParentsForChildSearch(this.dimensions, this.dimensionSearchQuery);
  },
  metricSearch() {
    this.expandParentsForChildSearch(this.metricsWithEnabled, this.metricSearchQuery);
  },

  // Watch metricsWithEnabled and automatically uncheck any metric that becomes disabled
  metricsWithEnabled: {
    deep: true, 
    handler(updatedMetrics) {
      
      const uncheckDisabled = (metric) => {
        // If the metric is disabled, uncheck it
        if (!metric._enabled) {
          metric._selected = false;
        }

        if (metric.children && metric.children.length) {
          metric.children.forEach(cd => {
            if (!cd._enabled) {
              cd._selected = false;
            }
          });
        }
      };

      updatedMetrics.forEach(metric => uncheckDisabled(metric));
    }
  }
},
methods: {
  search(...args) {
    return this.loadData(...args);
  },

  // Whitelist filters when config.visibleFilters is set (Reports: all | lite: datePicker, group_timeframe, pub/adv/offer).
  isFilterVisible(field) {
    if (!this.config || !this.config.visibleFilters) {
      return true;
    }
    return this.config.visibleFilters.includes(field);
  },

  // Pre-fill filters from Upload tab "View data" (lite only; regular Reports does not use this).
  applyQueryContext({ publisherId, date }) {
    if (publisherId !== null && publisherId !== undefined) {
      const pub = this.publisherOptions.find((p) => p.v === publisherId);
      this.filters.publisher_id = pub ? [pub] : [{ v: publisherId, t: String(publisherId) }];
    }
    if (date) {
      const day = moment(date).format('YYYY-MM-DD');
      this.filters.datePicker.dateRange.startDate = `${day} 00:00`;
      this.filters.datePicker.dateRange.endDate = `${day} 23:59`;
      this.filters.group_timeframe = 'day';
    }
    this.search(0);
  },

  // Checks if parent and all children metrics are enabled
  areAllMetricsEnabled(d) {
    if (!d._enabled) return false;
    if (d.children && d.children.length) {
      return d.children.every(cd => cd._enabled);
    }
    return true;
  },
  handleKeyPress(event) {
    if (event.key !== 'Enter') {
      return;
    }

    const activeEl = document.activeElement;
    const targetEl = event.target;

    const isInsideMultiselect =
      (activeEl && activeEl.closest('.multiselect')) ||
      (targetEl && targetEl.closest('.multiselect'));

    const isInSelectionPanel =
      (activeEl && activeEl.closest('.selection-panel')) ||
      (targetEl && targetEl.closest('.selection-panel'));

    if (isInsideMultiselect || isInSelectionPanel) {
      return;
    }

    this.search();
  },

  // Check if item matches search query
  matchesSearch(d, q) {
    if (!q) { return true; }
    if (d.label.toLowerCase().includes(q)) { return true; }
    if (d.children) { return d.children.some((cd) => cd.label.toLowerCase().includes(q)); }

    return false;
  },

  // Check if child item matches search query
  childVisible(cd, q) {
    return !q || cd.label.toLowerCase().includes(q);
  },
  expandParentsForChildSearch(items, q) {
    items.forEach((item) => {
      if (item._searchExpanded) {
        Vue.set(item, '_expanded', false); // collapse parent
        Vue.set(item, '_searchExpanded', false); // flag
      }
    });

    if (!q) { return; }

    items.forEach((item) => {
      if (!item.children) { return; }
      const childMatches = item.children.some((cd) => cd.label.toLowerCase().includes(q));
      if (childMatches && !item._expanded) {
        Vue.set(item, '_expanded', true); // expand parent
        Vue.set(item, '_searchExpanded', true); // flag indicating parent is expanded for child search
      }
    });
  },
  submitSelectionSearch(type) {
    const q = type === 'dimension' ? this.dimensionSearchQuery : type === 'metric' ? this.metricSearchQuery : '';
    const items = type === 'dimension' ? this.dimensions : type === 'metric' ? this.metricsWithEnabled : [];

    if (!q || !items.length) { return; } // no search query or no items -> do nothing

    // For each parent
    for (const item of items) {
      if (item.label.toLowerCase().includes(q) && !item.symbolic) {
        if (item._enabled !== false) {
          item._selected = true; // select parent
          this.clearSelectionSearch(type);
          return;
        }
      }

      // If item has children
      if (item.children) {
        for (const child of item.children) {
          if (child.label.toLowerCase().includes(q) && (type === 'dimension' || child._enabled)) { // metric should be 'enabled' to be selected
            child._selected = true; // select child
            if (type === 'dimension') {
              item._selected = true; // select parent when child is selected
            }
            this.clearSelectionSearch(type);
            return;
          }
        }
      }
    }
    this.clearSelectionSearch(type);
  },

  // Clear selection search
  clearSelectionSearch(type) {
    if (type === 'dimension') {
      this.dimensionSearch = '';
      this.$refs.dimensionSearchInput && this.$refs.dimensionSearchInput.blur();
    } else {
      this.metricSearch = '';
      this.$refs.metricSearchInput && this.$refs.metricSearchInput.blur();
    }
  },
  onTimegroupChange() {
    if (this.filters.group_timeframe !== 'none') {
      this.sortBy = [{ field: this.filters.group_timeframe, direction: 'desc', sort: null }];
    } else {
      this.sortBy = getDefaultSortBy();
    }
    if (this.accumulative && this.filters.group_timeframe !== 'hour') {
      this.accumulative = false;
    }
  },
  doSort({ field, direction, event }) {
    const isMulti = event && event.shiftKey;
    const idx = this.sortBy.findIndex(s => s.field === field);

    if (!isMulti) {
      this.sortBy = [{ field, direction }];
    } else {
      if (idx > -1) {
        this.$set(this.sortBy, idx, { field, direction });
      } else {
        this.sortBy.push({ field, direction });
      }
    }

    this.search();
  },
  getColClass(r, dim) {
    if (dim.name === 'offer') {
      const source = r.offer_id === 0 ? r.complex_offer : r.offer;
      // Offer status styling when final_status exists (Reports: yes | lite: skipped — no join data).
      if (!source || source.final_status === undefined) return '';
      return 'col-offer-status-' + source.final_status;
    }
    if (dim.name === 'placement') {
      if (!r.placement || r.placement.final_status === undefined) return '';
      return 'col-offer-status-' + r.placement.final_status;
    }
    // if (dim.name === 'sub1'){
    // 	return 'col-sub1-status-' + r.sub1.status;
    // }
    return '';
  },
  // Summary row: accept plain numbers or { v } objects (both Reports and lite API shapes).
  formatSummaryValue(value) {
    if (value == null || value === '') return '';
    const num = typeof value === 'object' && value.v != null ? value.v : value;
    return +num === num ? Number(num).toLocaleString() : String(num);
  },
  getRowClass(r) {
    if (this.dimHash.offer && this.dimHash.offer._selected) {
      const source = r.offer_id === 0 ? r.complex_offer : r.offer;
      // Row status class only when offer entity includes final_status (Reports: yes | lite: usually absent).
      if (!source || source.final_status === undefined) return '';
      return 'row-placement-status-' + source.final_status;
    }
    if (this.dimHash.placement && this.dimHash.placement._selected) {
      if (!r.placement || r.placement.final_status === undefined) return '';
      return 'row-placement-status-' + r.placement.final_status;
    }
    return '';
  },
  toggleViewMode(c, i) {
    if (c.mode === 'mini') {
      c.mode = 'normal';
    } else {
      c.mode = 'mini';
    }
    this.$set(this.columns, i, c);
  },

  toggleAllChildren(o) {
    o._toggled = !o._toggled;
    o.children.forEach((c) => {
      c._selected = o._toggled;
    });
  },

  clearFilters() {
    Vue.set(this.filters, 'datePicker', {
      timezone: 0,
      ...(this.hideTimezone ? { hideTZ: true } : {}),
      dateRange: {
        startDate: moment(
          moment()
            .subtract(-(new Date().getTimezoneOffset() / 60), 'hours')
            .format('DD/MM/YYYY') + ' 00:00',
          'DD/MM/YYYY HH:mm',
        ),
        endDate: moment(
          moment()
            .subtract(-(new Date().getTimezoneOffset() / 60), 'hours')
            .format('DD/MM/YYYY') + ' 23:59',
          'DD/MM/YYYY HH:mm',
        ),
      },
    });
    this.filtersOptions.forEach((f) => {
      Vue.set(this.filters, f.field, f.defaultValue);
    });
  },

  selectEntity(record, colIndex) {
    // console.log('select entity', record, colIndex);
    let col = this.columns[colIndex];
    switch (col.e) {
      case 'placement':
        //this.filters.placement_ids = '' + record[col.f];
        break;
      case 'offer':
        //this.filters.offer_ids = '' + record[col.f];
        break;
    }
  },

  appendEntity(record, dim) {
    switch (dim.name) {
      case 'placement':
        for (let k in this.filters.placement_id) {
          if (this.filters.placement_id[k].id == record[dim.name].id) {
            return false;
          }
        }
        this.filters.placement_id.push({
          id: record[dim.name].id,
          name: `[${record[dim.name].id}] ${record[dim.name].name}`,
        });
        break;
      case 'os_version':
        for (let k in this.filters.os_version_id) {
          if (this.filters.os_version_id[k].id == record[dim.name].id) {
            return false;
          }
        }
        this.filters.os_version_id.push({
          id: record[dim.name].id,
          name: `[${record[dim.name].id}] ${record[dim.name].name}`,
        });
        break;
      case 'offer':
        for (let k in this.filters.offer_id) {
          if (this.filters.offer_id[k].id == record[dim.name].id) {
            return false;
          }
        }
        this.filters.offer_id.push({
          id: record[dim.name].id,
          name: `[${record[dim.name].id}] ${record[dim.name].name}`,
        });
        break;
      case 'complex_offer':
        for (let k in this.filters.complex_offer_id) {
          if (this.filters.complex_offer_id[k].id == record[dim.name].id) {
            return false;
          }
        }
        this.filters.complex_offer_id.push({
          id: record[dim.name].id,
          name: `[${record[dim.name].id}] ${record[dim.name].name}`,
        });
        break;
      case 'advertiser':
        for (let k in this.filters.advertiser_id) {
          if (this.filters.advertiser_id[k].v == record[dim.name].id) {
            return false;
          }
        }
        this.filters.advertiser_id.push({
          v: record[dim.name].id,
          t: `[${record[dim.name].id}] ${record[dim.name].name}`,
        });
        break;
      case 'publisher':
        for (let k in this.filters.publisher_id) {
          if (this.filters.publisher_id[k].v == record[dim.name].id) {
            return false;
          }
        }
        this.filters.publisher_id.push({
          v: record[dim.name].id,
          t: `[${record[dim.name].id}] ${record[dim.name].name}`,
        });
        break;
      case 'mmp_account':
        for (let k in this.filters.mmp_account_id) {
          if (this.filters.mmp_account_id[k].v == record[dim.name].id) {
            return false;
          }
        }
        this.filters.mmp_account_id.push({
          v: record[dim.name].id,
          t: `[${record[dim.name].id}] ${record[dim.name].name}`,
        });
        break;
      case 'sub1':
        for (let k in this.filters.sub1_id) {
          if (this.filters.sub1_id[k].id == record[dim.name].id) {
            return false;
          }
        }
        this.filters.sub1_id.push({
          id: record[dim.name].id,
          name: record[dim.name].name,
        });
        break;
      case 'sub2':
        for (let k in this.filters.sub2_id) {
          if (this.filters.sub2_id[k].id == record[dim.name].id) {
            return false;
          }
        }
        this.filters.sub2_id.push({
          id: record[dim.name].id,
          name: record[dim.name].name,
        });
        break;
      case 'os':
      case 'device':
      case 'browser':
      case 'carrier':
      case 'isp':
      case 'am': {
        const entity = record[dim.name];
        if (!entity || entity.id === undefined || entity.id === null || entity.id === '') return false;
        const list = this.filters[`${dim.name}_id`];
        if (list.some((item) => item.v == entity.id)) return false;
        const options = {
          os: this.osOptions,
          device: this.deviceOptions,
          browser: this.browserOptions,
          carrier: this.carrierOptions,
          isp: this.ispOptions,
          am: this.accountManagerOptions,
        }[dim.name];
        const match = options.find((option) => option.v == entity.id);
        const created = match || {
          v: /^\d+$/.test(String(entity.id)) ? Number(entity.id) : entity.id,
          t: entity.name || '',
        };
        if (!match) options.push(created);
        list.push(created);
        break;
      }
      case 'country': {
        if (!record.country || record.country.id == null || record.country.id === '') return false;
        const code = String(record.country.id).trim().toUpperCase();
        if (!/^[A-Z]{2}$/.test(code)) return false;
        if (!Array.isArray(this.filters.country)) this.filters.country = [];
        if (this.filters.country.some((country) => country.v === code)) return false;
        const match = this.countryOptions.find((option) => option.v === code);
        const option = match || { v: code, t: code };
        if (!match) this.countryOptions.push(option);
        this.filters.country.push(option);
        break;
      }
      case 'media_type': {
        if (!record.media_type || record.media_type.id == null || record.media_type.id === '') return false;
        const key = ['dsp', 'rewarded', 'media_buying', 'push', 'pop', 'leadgen'][Number(record.media_type.id)];
        if (!key) return false;
        if (this.filters.media_type.some((item) => (item && item.v ? item.v : item) === key)) return false;
        const match = this.mediaTypeOptions.find((option) => option.v === key);
        this.filters.media_type.push(match || { v: key, t: record.media_type.name || key });
        break;
      }
      case 'attribution_type': {
        const raw = record.attribution_type;
        const value = raw === 'Impression' || raw === 1 || raw === '1' ? 1 : (raw === 'Click' || raw === 0 || raw === '0' ? 0 : null);
        if (value === null || this.filters.attribution_type === value) return false;
        this.filters.attribution_type = value;
        break;
      }
    }
    this.$forceUpdate();
  },

  searchIsp(keyword) {
    clearTimeout(this.ispSearchTimer);
    this.ispSearchTimer = setTimeout(async () => {
      this.ispOptionsLoading = true;
      try {
        const found = await Vue.ovData.geo.isp.getOptions({ keyword: keyword || '', limit: 50 });
        const selected = this.filters.isp_id;
        this.ispOptions = [
          ...selected,
          ...found.filter((option) => !selected.some((item) => item.v == option.v)),
        ];
      } catch (e) {
        console.error(e);
      }
      this.ispOptionsLoading = false;
    }, 300);
  },

  getURLFiltersParams(record, moreParams) {
    let params = {
      page: this.paginate.page,
      page_size: this.paginate.limit,
      keyword: this.filters.keyword,
      country: Array.isArray(this.filters.country)
        ? this.filters.country.map((country) => country.v || country).join(',')
        : this.filters.country,

      timezone: this.filters.datePicker.timezone,
      advertiser_id: this.filters.advertiser_id.map((r) => r.v).join(','),
      publisher_id: this.filters.publisher_id.map((r) => r.v).join(','),

      os_version_id: this.filters.os_version_id.map((r) => r.id).join(','),
      offer_id: this.filters.offer_id.map((r) => r.id).join(','),
      complex_offer_id: this.filters.complex_offer_id.map((r) => r.id).join(','),
      placement_id: this.filters.placement_id.map((r) => r.id).join(','),
      mmp_account_id: this.filters.mmp_account_id.map((r) => r.v).join(','),

      date_start: moment(this.filters.datePicker.dateRange.startDate).format('YYYY-MM-DD HH:mm'),
      date_end: moment(this.filters.datePicker.dateRange.endDate).format('YYYY-MM-DD HH:mm'),
    };

    if (typeof moreParams !== 'undefined' && moreParams) {
      Object.assign(params, moreParams);
    }
    if (this.filters.group_timeframe === 'month') {
      params.date_start = moment(record.group_month).startOf('month').format('YYYY-MM-DD HH:mm:00');
      params.date_end = moment(record.group_month).endOf('month').format('YYYY-MM-DD HH:mm:59');
    }
    if (this.filters.group_timeframe === 'week') {
      const [year, weekStr] = record.group_week.split('-W');
      const week = parseInt(weekStr, 10);

      const start = moment().year(year).isoWeek(week).startOf('isoWeek');
      const end = moment().year(year).isoWeek(week).endOf('isoWeek');

      params.date_start = start.format('YYYY-MM-DD HH:mm:00');
      params.date_end = end.format('YYYY-MM-DD HH:mm:59');
    }

    if (this.filters.group_timeframe === 'day') {
      params.date_start = moment(record.group_date).startOf('day').format('YYYY-MM-DD HH:mm:00');
      params.date_end = moment(record.group_date).endOf('day').format('YYYY-MM-DD HH:mm:59');
    }

    /**
     * We dont have any dates here, as this is a sum of hours for each date
     * in range, only group_hour like '05:00:00'.
     * In this case we check if only one day is selected, and if so, we use this
     * day as the date_start and date_end + selected hour.
     */
    if (this.filters.group_timeframe === 'hour') {
      const [dateStart, dateEnd] = [
        moment(this.filters.datePicker.dateRange.startDate).format('YYYY-MM-DD'),
        moment(this.filters.datePicker.dateRange.endDate).format('YYYY-MM-DD')
      ];
      if (dateStart === dateEnd) {
        const hourString = `${dateStart} ${record.group_hour}`;
        params.date_start = moment(hourString).startOf('hour').format('YYYY-MM-DD HH:mm:ss');
        params.date_end = moment(hourString).endOf('hour').format('YYYY-MM-DD HH:mm:ss');
      }
    }

    this.selectedDimensions.forEach((d) => {
      params[d.field] = record[d.field];
    });
    return params;
  },
  showBackgroundReportsModal() {
    this.$modal.show(
      GeneratedReportsModal,
      {},
      {
        height: '90%',
      },
    );
  },

  removeMetric: function (d) {
    d._selected = false;
  },
  removeDimension: function (d) {
    d._selected = false;

    this.sortBy = this.sortBy.filter((s) => d.name !== s.field);
    
    if (this.sortBy.length === 0) {
      this.sortBy = getDefaultSortBy();
    }
  },
  changeDimensionSelection(field, value) {
    this.accumulative = false;
    const d = this.dimensions.find((d) => d.field === field);
    if (!value) {
      this.removeDimension(d);
      return
    }
    d._selected = true;
  },
  // Select parent when (dimension) child is selected
  changeDimensionChildSelection(parent, child, value) {
    this.accumulative = false;
    child._selected = value;
    if (value) {
      parent._selected = true;
    }
  },

  toggleFilters: function () {
    this.filtersExpanded = !this.filtersExpanded;
  },
  getSelectedMetrics() {
    let metrics = [];
    this.metrics.forEach((m) => {
      if (m._selected) {
        metrics.push(m.name);
      }
      if (m.children) {
        m.children.forEach((cm) => {
          if (cm._selected) {
            metrics.push(cm.name);
          }
        });
      }
    });
    return metrics;
  },
  getSelectedDimensions() {
    return this.dimensions.filter((d) => d._selected).map((d) => d.name);
  },
  getSelectedInfo() {
    let infoRecords = [];
    this.dimensions.forEach((d) => {
      if (d.children) {
        d.children.forEach((cd) => {
          if (cd._selected) {
            infoRecords.push(`${d.name}__${cd.name}`);
          }
        });
      }
    });
    return infoRecords;
  },
  async loadData(doExport) {
    this.busy = true;

    let metrics = this.getSelectedMetrics();
    let dimensions = this.getSelectedDimensions();
    let info = this.getSelectedInfo();
    let dateStart = moment(this.filters.datePicker.dateRange.startDate);
    let dateEnd = moment(this.filters.datePicker.dateRange.endDate);
    
    if (this.sortBy.length === 0) {
      this.sortBy = getDefaultSortBy();
    }

    let params = {
      export: doExport ? doExport : 0,
      extended_params: this.filters.extended_params ? 1 : 0,
      page: this.paginate.page,
      page_size: this.paginate.limit,
      group_timeframe: this.filters.group_timeframe,
      timezone: this.filters.datePicker.timezone,
      date_start: dateStart.format('YYYY-MM-DD HH:mm'),
      date_end: dateEnd.format('YYYY-MM-DD HH:mm'),
      sort_col: this.sortBy.map(s => s.field),
      sort_dir: this.sortBy.map(s => s.direction),
      // user_id: this.filters.user_id,
      cohort: this.filters.cohort ? 1 : 0,
      accumulative: this.accumulative ? 1 : 0,
      groups_mode: this.filters.groups_mode,
      filters: {
        subsource_data: this.filters.subsource_data ? 1 : 0,
        conversions_mode: this.filters.conversions_mode,
        advertiser_id: this.filters.advertiser_id.map((r) => r.v),
        publisher_id: this.filters.publisher_id.map((r) => r.v),
        mmp_account_id: this.filters.mmp_account_id.map((r) => r.v),
        os_version_id: this.filters.os_version_id.map((r) => r.id),
        complex_offer_id: this.filters.complex_offer_id.map((r) => r.id),
        offer_id: this.filters.offer_id.map((r) => r.id),
        placement_id: this.filters.placement_id.map((r) => r.id),
        sub1_id: this.filters.sub1_id.map((r) => r.id),
        sub2_id: this.filters.sub2_id.map((r) => r.id),
        am_id: this.filters.am_id.map((r) => r.v),
        os_id: this.filters.os_id.map((r) => r.v),
        device_id: this.filters.device_id.map((r) => r.v),
        browser_id: this.filters.browser_id.map((r) => r.v),
        carrier_id: this.filters.carrier_id.map((r) => r.v),
        isp_id: this.filters.isp_id.map((r) => r.v),
        country: this.filters.country,
        media_type: getMediaTypeFilterValues(this.filters.media_type),
        attribution_type: this.filters.attribution_type,
        placement_po_model: this.filters.placement_po_model,
      },
      metrics: metrics,
      dimensions: dimensions,
      info: info
    };

    const queryParams = copy(params);
    delete queryParams.page;
    delete queryParams.export;
    if (shouldResetPageForQuery(this.previousQueryParams, queryParams)) {
      this.paginate.page = 1;
      params.page = 1;
    }

    let maxDimLevel = Math.max(
      ...this.dimensions.filter((d) => d._selected).map((d) => +d.level),
    );
    let dateSpan = dateEnd.diff(dateStart, 'days') + 1;
    let heavyReport = (maxDimLevel > 3 && dateSpan >= 7) || (maxDimLevel === 3 && dateSpan >= 30);

    /** suggest using doExport=3 (background report) in case of a heavy report */
    if (doExport === 1 && heavyReport) {
      let confirmed = await this.$bvModal.msgBoxConfirm(
        'This report is best advised to be exported via "Background Report" due to its dimensions and date span.\nAre you sure you want to proceed?',
      );
      if (confirmed) {
        await this.fetchData(params, doExport, queryParams);
      }
    } else {
      this.records = [];
      this.summary = null;
      this.resultMeta = null;

      await this.fetchData(params, doExport, queryParams);
    }
  },

  async fetchData(params, doExport, queryParams) {
    try {
      let resp = await this.$ovReq.post(this.queryUrl, params);
      this.previousQueryParams = copy(queryParams);
      if (doExport === 1 || doExport === 3) {
        const filename = moment().format('DD-MM-YYYY_HH:mm')
        await downloadFile(resp.path, filename)
      } else if (doExport === 2) {
        this.showBackgroundReportsModal();
      } else {
        this.columns = resp.columns;
        this.columns.forEach((c) => {
          Vue.set(c, 'mode', c.mode);
        });
        this.records = resp.records.slice(0, this.paginate.limit);
        this.summary = resp.summary;
        this.paginate.total = resp.total;
        this.resultMeta = {
          dimensions: resp.dimensions,
          metrics: resp.metrics,
        };
        this.paginate.numPages = Math.max(
          Math.ceil(this.paginate.total / this.paginate.limit),
          1,
        );
      }
    } catch (e) {
      console.log(e);
    }
    this.busy = false;
  },

  async loadCustomPresets() {
    this.customPresets = await Vue.ovData.report_preset.getUserPresets();
  },

  createCustomPreset() {
    let preset = Vue.ovData.report_preset.newInstance();
    preset.dimensions = [...this.getSelectedDimensions(), ...this.getSelectedInfo()];
    preset.metrics = this.getSelectedMetrics();
    preset.sort_by = this.sortBy;
    preset.filters = this.filtersOptions.reduce((acc, f) => {
      acc[f.field] = this.filters[f.field];
      return acc;
    }, {});
    delete preset.filters.datePicker;

    this.$modal.show(
      CreatePresetModal,
      {
        preset,
        dateRangeOptions: Object.keys(this.$refs.datePickerRef.datePickerOptions.ranges),
      },
      null,
      {
        'before-close': (/*event*/) => {
          this.loadCustomPresets();
        },
      },
    );
  },

  async deleteCustomPreset(p) {
    let confirmed = await this.$bvModal.msgBoxConfirm(`Delete "${p.name}" preset?`, { title: 'Delete Preset' });
    if (!confirmed) {
      return;
    }
    await this.$ovReq.post('reportPreset/delete', {
      id: p.id,
    });
    this.$ovNotify.success(`"${p.name}" was deleted`);
    await this.loadCustomPresets();
  },

  async togglePresetDefault(p) {
    if (!p.is_default) {
      await this.$ovReq.post('reportPreset/setDefault', {
        id: p.id,
      });
      this.$ovNotify.success(`"${p.name}" was set to default`);
    } else {
      await this.$ovReq.post('reportPreset/removeDefault', {
        id: p.id,
      });
      this.$ovNotify.success(`"${p.name}" was set to default`);
    }
    await this.loadCustomPresets();
  },

  async editCustomPreset(p) {
    this.selectCustomPreset(p, false);
    this.presetDateRangeOptions = Object.keys(this.$refs.datePickerRef.datePickerOptions.ranges);
    let activeFilters = {};
    this.filtersOptions.forEach((f) => {
      activeFilters[f.field] =
        !p.filters.hasOwnProperty(f.field) || p.filters[f.field] !== 'ignore';
    });
    p.activeFilters = activeFilters;
    this.presetEditInstance = p;
  },

  async onPresetDrag(evt) {
    if (!evt || evt.oldIndex == null || evt.newIndex == null || evt.oldIndex === evt.newIndex) {
      return;
    }
    await this.$nextTick();
    this.presetOrderChange = true;
    this.customPresets.forEach((o, i) => {
      o.display_order = i;
    });
    await this.updatePresetOrder();
  },

  async updatePresetOrder() {
    if (this.presetOrderChange) {
      let presetOrderList = this.customPresets.map((o) => ({
        id: o.id,
        display_order: o.display_order,
      }));
      try {
        await this.$ovReq.post('reportPreset/updateOrder', { presets: presetOrderList });
        this.presetOrderChange = false;
      } catch (e) {
        console.error(e);
      }
    }
  },

  async updateCustomPreset() {
    if (this.busy) {
      return;
    }
    let preset = Vue.util.extend({}, this.presetEditInstance);
    preset.dimensions = [...this.getSelectedDimensions(), ...this.getSelectedInfo()];
    preset.metrics = this.getSelectedMetrics();
    preset.sort_by = this.sortBy;
    for (let f in preset.activeFilters) {
      preset.filters[f] = preset.activeFilters[f] ? this.filters[f] : 'ignore';
    }
    if (preset.filters.hasOwnProperty('datePicker')) {
      delete preset.filters.datePicker;
    }

    this.busy = true;
    try {
      await this.$ovReq.post('reportPreset/save', preset);
      this.$ovNotify.success('preset has been saved');
      this.presetEditInstance = null;
      await this.loadCustomPresets();
    } catch (e) {
      console.error(e);
    }
    this.busy = false;
  },

  selectCustomPreset(p, loadData = true) {
    this.selectedPreset = p;

    /** filters */
    this.accumulative = false;

    for (const f of this.filtersOptions) {
      if (p.filters.hasOwnProperty(f.field)) {
        if (p.filters[f.field] !== 'ignore') {
          this.$set(this.filters, f.field, copy(p.filters[f.field]));
        }
      } else {
        this.filters[f.field] = f.defaultValue;
      }
    }
    const selectedMediaTypeValues = getMediaTypeFilterValues(this.filters.media_type);
    this.filters.media_type = this.mediaTypeOptions.filter((option) =>
      selectedMediaTypeValues.includes(option.v)
    );
    const storedCountry = this.filters.country;
    const countryCodes = (Array.isArray(storedCountry) ? storedCountry : String(storedCountry || '').split(/[\s,]+/))
      .map((country) => String(country && country.v ? country.v : country).trim().toUpperCase())
      .filter((code) => /^[A-Z]{2}$/.test(code));
    this.filters.country = [...new Set(countryCodes)].map((code) => {
      return this.countryOptions.find((option) => option.v === code) || { v: code, t: code };
    });

    /** sort by */
    if (!Array.isArray(p.sort_by)) {
      this.sortBy = [p.sort_by];
    } else {
      this.sortBy = p.sort_by;
    }

    /** date range */
    if (p.date_range) {
      this.$refs.datePickerRef.setRangeByKey(p.date_range);
    }

    /** dimensions */
    this.dimensions.forEach((d) => {
      let selected = p.dimensions.indexOf(d.name) > -1;
      Vue.set(d, '_selected', selected);
      if (d.children) {
        d.children.forEach((cd) => {
          const childName = `${d.name}__${cd.name}`;
          let selected = p.dimensions.includes(childName);
          Vue.set(cd, '_selected', selected);
        });
      }
    });

    /** metrics */
    this.metrics.forEach((d) => {
      let selected = p.metrics.indexOf(d.name) > -1;
      Vue.set(d, '_selected', selected);
      if (d.children) {
        d.children.forEach((cd) => {
          let selected = p.metrics.indexOf(cd.name) > -1;
          Vue.set(cd, '_selected', selected);
        });
      }
    });

    setTimeout(() => {
      if (loadData) {
        this.search(0);
      }
    }, 300);
  },

  copyToClipboard() {
    // console.log(this.$refs.table.innerText);
    this.$copyText(this.$refs.table.innerText).then(
      function (e) {
        // alert('Copied');
        console.log(e);
      },
      function (e) {
        // alert('Can not copy');
        console.log(e);
      },
    );
  },

  toggleAccumulativeMode() {
    if (this.accumulative) {
      this.filters.group_timeframe = 'hour';
      this.sortBy = [{ field: 'hour', direction: 'desc', sort: null }];
      if (this.filters.datePicker.timezone !== 0) {
        this.filters.datePicker.timezone = moment().utcOffset();
      }
      if (moment(this.filters.datePicker.dateRange.startDate).hour() !== 0 || moment(this.filters.datePicker.dateRange.endDate).hour() !== 23 || moment(this.filters.datePicker.dateRange.startDate).format('YYYY-MM-DD') !== moment(this.filters.datePicker.dateRange.endDate).format('YYYY-MM-DD')) {
        this.filters.datePicker.dateRange.startDate = moment().startOf('day').format('YYYY-MM-DD') + ' 00:00';
        this.filters.datePicker.dateRange.endDate = moment().endOf('day').format('YYYY-MM-DD') + ' 23:59';
      }
      this.dimensions.forEach((d) => {
        Vue.set(d, '_selected', false);
        if (d.children) {
          d.children.forEach((cd) => {
            Vue.set(cd, '_selected', false);
          });
        }
      });
      
      this.search();
    }
  },

  onDateTimeChange(event) {
    if (this.accumulative && (event.timezone !== 0 || moment(event.dateRange.startDate).hour() !== 0 || moment(event.dateRange.endDate).hour() !== 23 || moment(event.dateRange.startDate).format('YYYY-MM-DD') !== moment(event.dateRange.endDate).format('YYYY-MM-DD'))) {
      this.accumulative = false;
    }
  },
},
async mounted() {
  let vm = this;
  vm.busy = true;
  vm.$nextTick(async () => {
    try {
    let formInfo = await Vue.ovReq.get(this.formInfoUrl);
    let filterOptions = Vue.ovData.report_preset.getAllFilters();
    // Skip loading user presets when Presets column is hidden (Reports: load | lite: []).
    let customPresets = this.showPresets
      ? await Vue.ovData.report_preset.getUserPresets()
      : [];
    let advertiserOptions = await Vue.ovData.advertiser.getOptions(true);
    let publisherOptions = await Vue.ovData.publisher.getOptions(true);
    let accountManagerOptions = await Vue.ovData.user.getOptions(true, ['admin', 'am']);
    let mmpAccountOptions = await Vue.ovData.mmpAccount.getOptions(true);

    let selectedOfferOptions = await Vue.ovData.offer.getSelectedOptions(this.offer_id);
    const res = await Vue.ovData.offer.getSelectedOptions(this.offer_id);
    let offer = res.entity;
    let selectedOsVersionOptions = await Vue.ovData.offer.getSelectedOptions(this.os_version_id);
    let selectedComplexOptions = await Vue.ovData.offer.getSelectedOptions(this.complex_offer_id);
    let selectedPlacementOptions = await Vue.ovData.placement.getSelectedOptions(
      this.placement_id,
    );

    this.advertiserOptions = advertiserOptions;
    this.publisherOptions = publisherOptions;
    this.filters.offer_id = selectedOfferOptions;
    this.filters.os_version_id = selectedOsVersionOptions;
    this.filters.complex_offer_id = selectedComplexOptions;
    this.filters.placement_id = selectedPlacementOptions;
    this.accountManagerOptions = accountManagerOptions;
    this.mmpAccountOptions = mmpAccountOptions;
    this.customPresets = customPresets;
    this.filtersOptions = filterOptions;
    this.filters.user_id = this.$store.state.user.id;
    // Lite getFormInfo may omit filter option lists — default to empty (Reports: populated from API).
    const formOptions = formInfo.options || {};
    this.browserOptions = formOptions.browser || [];
    this.osOptions = formOptions.os || [];
    this.deviceOptions = formOptions.device || [];
    this.carrierOptions = formOptions.carrier || [];
    try {
      const countryRecords = await Vue.ovData.country.getOptions();
      this.countryOptions = (countryRecords || [])
        .filter((country) => country && country.code)
        .map((country) => {
          const code = String(country.code).trim().toUpperCase();
          return { v: code, t: `${country.name || code} (${code})` };
        })
        .filter((country) => /^[A-Z]{2}$/.test(country.v))
        .sort((a, b) => a.t.localeCompare(b.t));
    } catch (e) {
      console.error(e);
    }
    this.blockedErrors = formInfo.blockedErrors || [];
    this.rejectReasons = formInfo.rejectReasons || [];
    this.MetricsValidationRules = formInfo.MetricsValidationRules || { metrics: {} };
    this.ctitSteps = formInfo.ctitSteps || [];
    this.dimensions = formInfo.dimensions || [];
    this.dimensions.forEach((d) => {
      Vue.set(d, '_selected', this.configuredDefaultDimensions.includes(d.name));
      Vue.set(d, '_expanded', false);
      this.dimHash[d.name] = d;
    });
    this.metricsHash = {};
    this.metrics = formInfo.metrics || [];
    this.metrics.forEach((d) => {
      // Attach drill-down routes on metrics (Reports: enabled | lite: disabled via disableMetricLinks).
      if (!this.disableMetricLinks) {
        switch (d.name) {
          case 'installs':
            d.link = 'events';
            d.linkParams = { event_name: 'install' };
            break;
          case 'conversions':
            d.link = 'conversions';
            break;
          case 'publisher_conversions':
            d.link = 'pub_conversions';
            break;
          case 'reported_conversions':
            d.link = 'pub_conversions';
            d.linkParams = { reported: 1 };
            break;
          case 'events':
            d.link = 'events';
            break;
          case 'reject_events':
            d.link = 'rejected';
            break;
        }
      }
      Vue.set(d, '_expanded', false);
      Vue.set(d, '_selected', this.configuredDefaultMetrics.includes(d.name));
      if (d.children) {
        d.children.forEach((c) => {
          Vue.set(c, '_selected', this.configuredDefaultMetrics.includes(c.name));
          this.metricsHash[c.name] = c;
        });
      }
      this.metricsHash[d.name] = d;
    });

    // Hide timezone control on date picker when backend ignores timezone (Reports: false | lite: true).
    if (this.hideTimezone) {
      Vue.set(this.filters.datePicker, 'hideTZ', true);
    }

    this.filters.user_id = this.$store.state.user.id;
    // Auto-run first query on mount when config.loadOnStart is set (lite: true | Reports: usually unset).
    if (vm.config && vm.config.loadOnStart) {
      let openedByLink = this.os_version_id || this.offer_id || this.complex_offer_id || this.placement_id;
      let defaultPreset = this.customPresets.find((p) => p.is_default);
      if (!openedByLink && defaultPreset && !this.date_filters_only && this.showPresets) {
        this.selectCustomPreset(defaultPreset);
      } else {
        this.loadData(0);
      }
    }
    } catch (e) {
      console.error(e);
      this.$ovNotify.error('Failed to load report form');
      vm.busy = false;
    }
  });

  // Add the global key event listener
  document.addEventListener('keydown', this.handleKeyPress);
},
beforeDestroy() {
  clearTimeout(this.ispSearchTimer);
  document.removeEventListener('keydown', this.handleKeyPress);
},
};
</script>
